import {Offer} from "@/lib/interfaces/offers";
import {apiFetch} from "@/lib/api";

export const getByArea = (title: string, options?:{}): Promise<Offer[]> => {
    return apiFetch(`area-offers/${title}`, options)
        .then(res => res.json())
        .then(res => {
            return res.data.map((offer: any) => {
                return offer as Offer
            });
        });
}